import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { WebdokuService } from '../web-doku/webdoku.service';

@Injectable({
  providedIn: 'root',
})
export class NeedWebDokuGuard  {
  private webdokuService = inject(WebdokuService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.webdokuService.isWebDokuSelected;
  }
}
